export config from './config';
export {
	PAGES,
} from './pages';

export {
	iamMessages,
} from './iamMessages';



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/config/index.js